// @flow

import * as React from "react";
import { isNil, map } from "lodash";

export type SelectorChoice = {
  /** The unique identifier for each choice. Can be size, an option or a product name */
  id: string,

  /** Title is the top line content in a button. */
  title: string | React.Node
};

export type SelectorProps = {
  /** The current selected `id` value.
   *  Even the `selected` is not null, it still may not present in `map(choices, "id")`.
   *  For example, of all the Selector in large format prints, only one should have a
   *  valid `id`.
   *  */
  selected: ?string,

  /** All available choices. */
  choices: Array<SelectorChoice>,

  /** Callback when a new option is selected. The string is the `id` of `SelectorChoice`.*/
  onSelect: string => void
};

const Selector = (
  { selected, choices, onSelect }: SelectorProps // `props.layout` has a default value as `full`.
) => (
  // If it is not "compact", get the `widthClass`. Otherwise, set it to "compact"
  <div className={`selector`}>
    <div className={"selector-wrapper"}>
      {map(choices, ({ id, title }) => (
        <div
          key={id}
          className={`btn ${
            !isNil(selected) && id === selected ? "btn-primary" : ""
          } selector--btn-choice `}
          onClick={() => onSelect(id)}>
          <div className="selector--btn-choice selector--btn-choice--vertical-wrapper">
            <span className="btn--title">{title}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

Selector.displayName = "Selector";

export default Selector;
